import { Form, Formik, FormikHelpers, useFormikContext } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { AppContext } from "../../../appContext/AppContext";
import { RESPONSE_CODE_SUCCESS } from "../../../category-personnel/const/PersonnelConst";
import { ConfirmDialog } from "../../../component/ConfirmDialog";
import CustomIconButton from "../../../component/custom-icon-button/CustomIconButton";
import GenerateFormComponent from "../../../component/generate-form/GenerateFormHTMLNoValid";
import DynamicComponent from "../../../component/GenerateDynamicComponent";
import { TableCustomHeader } from "../../../component/table/components/TableCustomHeader";
import { TableCustom } from "../../../component/table/table-custom/TableCustom";
import { CODE_DIEU_CHUYEN } from "../../../phan-he-dieu-chuyen/constants/constansDieuChuyen";
import { WMS_STATUS } from "../../../phan-he-nhap-kho/constants/constansNhapKho";
import { extractColumnsTableCustom, generateForm, generateHrTag } from "../../../utils/AppFunction";
import { CODE, DEFAULT_PAGE_INDEX, MAX_PAGE_SIZE, SELECTION_MODE, TYPE_WH, WF_TRACKER } from "../../../utils/Constant";
import WfButton from "../../../workflows/components/WfButton";
import { HoanTraVatTuColumns } from "../../constants/TuTrucColumns";
import '../../PhanHeTuTruc.scss';
import "./index.scss";
import { createPhieuHoanTraVatTu, getDsVatTuPhieu, getListMedicine, printPhieu, printPhieuHoanTra, updatePhieuHoanTraVatTu } from "./services";
import { useIntl } from "react-intl";
import { formatDateDTO } from "../../../utils/FormatUtils";
import { OctGenerateForm } from "@oceantech/oceantech-ui";
import BackButton from "../../../component/BackButton";
import ModelHeader from "../../../component/ModelHeader";
import ButtonIn from "../../../component/button-in-phieu";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  modelId: any;
  typeWf?: any;
  onlyNhapKho?: boolean;
}

// Các trường thông tin của thuốc/vật tư đang nhập trên form
const ITEM_FIELDS = ["name", "totalQuantity", "unitOfMeasureName", "code", "specification", "manufacturer", "countryOfOrigin", "consignment", "expiryDate", "iventory", "sellingPrice", "vat", "totalAmount", "itemId", "serialNumber"];
// Các trường của phiếu, luôn giữ lại khi tách thông tin thuốc ra khỏi form
const SLIP_FIELDS = ["id", "statusCode", "type", "warehouseExportType", "createdDate", "doCreation", "createdBy", "creator", "notes", "department", "departmentId", "departmentName", "transferWh", "transferWhId", "transferWhName", "reqWh", "reqWhId", "reqWhName", "whReceive", "whIssue", "whIssueId", "whIssueName", "warehouseId"];

// Form dùng chung cho thông tin phiếu và thuốc đang nhập => bỏ các trường của thuốc, chỉ giữ thông tin phiếu
const getSlipFields = (formValues: any = {}) => {
  const slipFields = { ...formValues };
  [
    ...ITEM_FIELDS, "item", "idFake", "iventoryInit", "tempItem", "requireQuantity", "CountryOfOrigin",
    ...Object.keys(formValues?.tempItem || {}),
    ...Object.keys(formValues?.item || {}),
  ]
    .filter((key: string) => !SLIP_FIELDS.includes(key))
    .forEach((key: string) => delete slipFields[key]);
  return slipFields;
}

const DialogThemPhieuHoanTraVatTu = (props: Props) => {
  const { show, onHide, initialValues, typeWf = 2, modelId, onlyNhapKho } = props;
  const { setIsLoading } = useContext(AppContext);
  const intl = useIntl();
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [lstItem, setLstItem] = useState<any>([])
  const [itemSelected, setItemSelected] = useState<any>([] as any)
  const [openDialogConfirmDelete, setOpenDialogConfirmDelete] = useState(false)
  const [statusPhieu, setStatusPhieu] = useState<any>({ status: WMS_STATUS.warehouse_export_start });
  const formRef = useRef<any>()
  const [idItem, setIdItem] = useState('')
  const departmentRef = useRef('');
  const slipIdRef = useRef('');
  const getSlipId = () => initialValues[modelId.id]?.id || slipIdRef.current || null;
  const caculatorTotalAmount = (values: any) => Number(values?.totalQuantity) * (Number(values?.sellingPrice) + ((Number(values?.vat || 0) / 100) * Number(values?.sellingPrice)))
  const clearValues = (setFieldValue: FormikHelpers<Record<string, any>>['setFieldValue']) => {
    ITEM_FIELDS.forEach((key: string) => {
      setFieldValue(`${modelId.id}.${key}`, '')
    })
  }

  useEffect(() => {
    getSelectedRowsData(initialValues[modelId.id]?.id);
    setStatusPhieu({
      status: initialValues[modelId.id]?.statusCode,
    })
  }, [initialValues[modelId.id]?.id]);

  useEffect(() => {
    updateForm();
  }, []);

  useEffect(() => {
    generateHrTag('#kt_app_body > div.fade.page-full.spaces.h-calc-vh-50.modal.show > div > div > form > div.spaces.p-0.bg-white.modal-body > div.spaces.px-10.mb-10 > div > form > div:nth-child(2) > div.themPhieuXuatSuDung-columns6-1.col-lg-6')
    let hrTag = document.getElementsByTagName("hr");
    if (hrTag.length > 0) {
      hrTag[0].style.marginTop = "12px";
    }
  }, [listJsonGenerate])

  const validationSchema = Yup.object({
    [modelId.id]: Yup.object({
      transferWh: Yup.string().required(intl.formatMessage({ id: "VALIDATION.REQUIRE" })).nullable(),
    })
  })

  const handlerMedicine = (value?: any, values?: any, setFieldValue?: any) => {
    let obj = {
      ...getSlipFields(values[modelId.id]), // không để thông tin của thuốc chọn trước đè lên thuốc mới
      tempItem: value,
      id: getSlipId(), // không để id của thuốc/dòng đang sửa đè lên id phiếu
      totalQuantity: values[modelId.id]?.totalQuantity,
      iventory: Number(value.iventory),
      unitOfMeasureName: value.unitofMeasureName,
      code: value.code,
      countryOfOrigin: null, //Nước sản xuất
      manufacturer: null, //Hãng sản xuất
      consignment: value.consignment, // Số lô
      specification: null, //Quy cách
      name: value.name,
      itemId: value.id,
      sellingPrice: Number(value.sellingPrice),
      serialNumber: value.serialNumber,
      expiryDate: value?.expiryDate,
      createdDate: values[modelId.id]?.createdDate
    }
    delete obj?.[modelId.id];
    setFieldValue(modelId.id, obj)
  }

  const handlerAddWithJs = async (values: any, setFieldValue: any) => {
    values[modelId.id].iventoryInit = values[modelId.id].iventory;
    if (!values[modelId.id].name) return toast.warning("Vui lòng chọn thuốc!")
    if (!values[modelId.id].totalQuantity) return toast.warning("Số lượng không được để trống!")
    if (values[modelId.id].totalQuantity <= 0 || isNaN(values[modelId.id].totalQuantity) || values[modelId.id].totalQuantity > values[modelId.id].iventory) return toast.warning("Số lượng nhập không được vượt số lượng tồn trong kho!")
    if (itemSelected.idFake || itemSelected.id) { // Cập nhật
      let arr = lstItem.map((item: any) => {
        if (item.idFake !== itemSelected.idFake || item.id !== itemSelected.id) return item;
        return { ...itemSelected, ...values[modelId.id], id: itemSelected.id, idFake: itemSelected.idFake, totalAmount: caculatorTotalAmount(values[modelId.id]) }
      })
      setItemSelected({})
      setLstItem(arr)
    }
    clearValues(setFieldValue)
    !itemSelected.idFake && !itemSelected.id && setLstItem([...lstItem, generateItemDto(values)])
  };

  const updateForm = async () => {
    const data = await generateForm(modelId.id, setIsLoading);
    setListJsonGenerate(data || []);
  };

  const generateSlipDto = (values: any) =>
  ({
    ...initialValues[modelId.id],
    ...values[modelId.id],
    id: getSlipId(), // id của phiếu, không lấy theo id dòng thuốc đang sửa
    createdDate: formatDateDTO(values[modelId.id]?.createdDate),
    doCreation: formatDateDTO(values[modelId.id]?.doCreation),
    warehouseId: values[modelId.id]?.reqWh?.id || values[modelId.id]?.reqWhId || initialValues[modelId.id]?.reqWhId,
    code: values[modelId.id].code,
    idFake: new Date(),
    sellingPrice: Number(values[modelId.id].sellingPrice) || 0,
    totalQuantity: Number(values[modelId.id].totalQuantity) || 0,
    totalAmount: caculatorTotalAmount(values[modelId.id]),
    vat: Number(values[modelId.id].vat) || 0,
    reqWh: values[modelId.id]?.reqWh?.code || values[modelId.id]?.reqWh || initialValues[modelId.id]?.reqWh,
    reqWhName: values[modelId.id]?.reqWh?.whReceiveName || values[modelId.id]?.reqWhName || initialValues[modelId.id]?.reqWhName,
    reqWhId: values[modelId.id]?.reqWh?.id || values[modelId.id]?.reqWhId || initialValues[modelId.id]?.reqWhId,
    type: TYPE_WH.TRANSFER,
    warehouseExportType: CODE_DIEU_CHUYEN.HOAN_TRA_VAT_TU,
  })

  // Dòng thuốc thêm vào bảng: không mang id của phiếu để tránh sửa/xóa nhầm dòng
  const generateItemDto = (values: any) => ({ ...generateSlipDto(values), id: null })

  const handleSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
    let id = getSlipId();
    if (!lstItem.length) return toast.warning("Chưa có thuốc/VT!")
    try {
      setIsLoading(true)
      const data = {
        slipDto: { ...generateSlipDto(values), tempItem: null },
        lstItem: lstItem.map((item: any) => {
          const _item = {
            ...item?.tempItem,
            ...item,
            iventory: Number(item.iventory),
            tempItem: null,
            id: item?.id || null, // id dòng chi tiết phiếu (null với dòng mới thêm)
            requireQuantity: item?.totalQuantity,
            itemId: item?.itemId,
            serialNumber: item?.serialNumber,
            code: item?.code,
            name: item?.name,
            consignment: item?.consignment,
            expiryDate: item?.expiryDate,
            createdDate: item?.createdDate,
          }
          delete _item.tempItem
          return _item
        })
      };
      let res = id ?
        await updatePhieuHoanTraVatTu(id, data) :
        await createPhieuHoanTraVatTu(data);
      if (res?.data?.code === RESPONSE_CODE_SUCCESS) {
        toast.success(id ? "Cập nhật phiếu thành công" : "Thêm mới phiếu thành công");
        const slipId = res?.data?.data?.id || id;
        slipIdRef.current = slipId;
        // Load lại chi tiết để các dòng có id, lần lưu sau mới gửi được id lên (tránh tạo trùng dòng)
        await getSelectedRowsData(slipId);
        setTimeout(() => {
          formikHelpers.setValues({
            ...values,
            [modelId.id]: {
              ...values[modelId.id],
              id: slipId,
              notes: values[modelId.id].notes,
            }
          })
        }, 200);
      }
    } catch (error) {
      console.error("ERR", error)
    } finally {
      setIsLoading(false)
    }
  };

  const getSelectedRowsData = async (id: string) => {
    try {
      setIsLoading(true);
      const { data } = id ? await
        getDsVatTuPhieu({
          pageSize: MAX_PAGE_SIZE, pageIndex: DEFAULT_PAGE_INDEX, slipId: id,
        }) : await getListMedicine({
          pageSize: MAX_PAGE_SIZE,
          pageIndex: DEFAULT_PAGE_INDEX,
          warehouseId: initialValues[modelId.id]?.whReceive?.id,
          type: 2 // Xuất
        })
      if (CODE.SUCCESS === data.code) {
        let values = id ? data.data.content : data.data;
        // Chỉ dòng chi tiết của phiếu mới có id, danh sách thuốc trong kho không phải dòng chi tiết
        setLstItem(values.map((item: any) => ({ ...item.item, ...item, id: id ? item.id : null, unitOfMeasureName: item.item?.unitofMeasureName })))
      } else {
        toast.error('Có lỗi xảy ra, vui lòng thử lại');
      };
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const columnsActions = {
    Header: (props: any) => (
      <TableCustomHeader<any>
        tableProps={props}
        title={"Thao tác"}
        className='text-center text-light min-w-80px'
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => (
      <div className="d-flex justify-content-center gap-3">
        {((!statusPhieu.status || statusPhieu.status === WMS_STATUS.warehouse_export_start) && !onlyNhapKho) &&
          <>
            <CustomIconButton
              variant="edit"
              onClick={() => {
                setItemSelected({ ...props.cell.row.original });
              }}
            >
              <i className={`spaces bi bi-pencil-square text-navy ${(modelId.title) ? 'mr-5' : 'mx-0'}`}></i>
            </CustomIconButton>

            <CustomIconButton
              variant="delete"
              onClick={() => {
                setIdItem(props.cell.row.original.id ? props.cell.row.original.id : props.cell.row.original.idFake);
                setOpenDialogConfirmDelete(true);
              }}
            >
              <i className="bi bi-trash3-fill text-danger"></i>
            </CustomIconButton>
          </>
        }
      </div>
    )
  };

  const handleDeletePhieu = () => {
    let arr = [...lstItem.filter((item: any) => ![item.idFake, item.id].includes(idItem))]
    setLstItem(arr)
    setOpenDialogConfirmDelete(false)
  }

  const FormObserver = () => {
    const { values, setFieldValue, setValues } = useFormikContext();
    useEffect(() => {
      const totalAmount = caculatorTotalAmount((values as any)[modelId.id]);
      setValues((prevValues: any) => ({
        ...prevValues,
        [modelId.id]: {
          ...prevValues[modelId.id],
          totalAmount: totalAmount
        }
      }))
    }, [(values as any)[modelId.id]?.totalQuantity, (values as any)[modelId.id]?.sellingPrice, (values as any)[modelId.id]?.vat]);

    useEffect(() => {
      if (!itemSelected.idFake && !itemSelected.id) return;
      setFieldValue(modelId.id,
        initialValues[modelId.id]?.id ? {
          ...itemSelected,
          createdBy: initialValues[modelId.id]?.createdBy,
          reqWh: initialValues[modelId.id]?.reqWh,
          department: initialValues[modelId.id]?.department,
          notes: initialValues[modelId.id]?.notes,
          createdDate: initialValues[modelId.id]?.createdDate,
          unitOfMeasureName: itemSelected?.item?.unitofMeasureName,
          iventory: itemSelected?.iventoryInit ? itemSelected?.iventoryInit : itemSelected?.item?.iventory,
        } : {
          ...itemSelected,
          createdDate: initialValues[modelId.id]?.createdDate,
          iventory: itemSelected?.iventoryInit ? itemSelected?.iventoryInit : itemSelected?.item?.iventory,
        })
    }, [itemSelected])

    useEffect(() => {
      if (departmentRef.current != (values as any)[modelId.id]?.department && (values as any)[modelId.id]?.department && departmentRef.current != undefined) {
        setLstItem([])
        setItemSelected({})
        clearValues(setFieldValue)
      }
      departmentRef.current = (values as any)[modelId.id]?.department
    }, [(values as any)[modelId.id]?.department]);

    useEffect(() => {
      if (!values) return;

      const eleTotalQuantity = document.querySelector<HTMLInputElement>(
        "input[name='totalQuantity']"
      );
      if (!eleTotalQuantity) return;

      eleTotalQuantity.setAttribute('min', '0');

      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        'value'
      )?.set;

      const setNativeValue = (el: HTMLInputElement, value: string) => {
        nativeInputValueSetter?.call(el, value);
        el.dispatchEvent(new Event('input', { bubbles: true }));
      };

      const handlerValidateSl = function (this: HTMLInputElement) {
        const value = this.value;

        if (value === '') return;

        const valueAsNumber = parseFloat(value);

        if (!isNaN(valueAsNumber) && valueAsNumber < 0) {
          setNativeValue(this, '0');
        }
      };

      eleTotalQuantity.addEventListener('input', handlerValidateSl);

      return () => {
        eleTotalQuantity.removeEventListener('input', handlerValidateSl);
      };
    }, [values]);

    return null;
  }
  console.log(statusPhieu)
  return (
    <Modal
      centered
      show={show}
      onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50"
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, touched, errors, handleChange, setFieldValue }) => {
          return <Form ref={formRef} >
            <ModelHeader onHide={onHide} title={modelId.title && `${values[modelId.id]?.id || slipIdRef.current ? 'Cập nhật' : 'Thêm mới'} ${modelId.title}`} />
            <Modal.Body className="spaces p-0 bg-white">
              <div className="spaces px-10 mb-10">
                <div>
                  <OctGenerateForm
                    warehouseId={initialValues[modelId.id]?.reqWh?.id || initialValues[modelId.id]?.reqWhId}
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    values={values}
                    touched={touched}
                    errors={errors}
                    modelID={modelId.id}
                    customComponent={DynamicComponent}
                    lstSelectedRenderButton={lstItem}
                    propsRenderButton={(e: any) => handlerMedicine(e, values, setFieldValue)}
                    isViewSelectThuoc={(statusPhieu.id && statusPhieu.status !== WMS_STATUS.warehouse_export_start) || onlyNhapKho}
                    isView={(statusPhieu.id && statusPhieu.status !== WMS_STATUS.warehouse_export_start) || onlyNhapKho}
                    DynamicClass='p-0'
                  />
                </div>
                {
                  <Button disabled={onlyNhapKho || (statusPhieu?.status && WMS_STATUS.warehouse_export_start !== statusPhieu?.status)} className="btn btn-fill custom-position-btn spaces min-w-90px mt-10" onClick={() => handlerAddWithJs(values, setFieldValue)}>
                    {(itemSelected.idFake || itemSelected.id) ? 'Cập nhật' : 'Thêm'}
                  </Button>
                }
              </div>
              <div className="spaces bg-white mb-0">
                <TableCustom<any>
                  key={statusPhieu?.status}
                  className={`spaces ${modelId.title ? "h-70vh" : "h-72vh"}`}
                  data={lstItem}
                  columns={extractColumnsTableCustom(listJsonGenerate)}
                  columnsActions={columnsActions}
                  verticalScroll={true}
                  selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}
                />
              </div>
            </Modal.Body>
            <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6">
              {/* {(
                ((onlyNhapKho && statusPhieu.id === WMS_STATUS.id_warehouse_wait_import) || !statusPhieu.id) //Sd bên kho, chỉ hiện wf khi phiếu đang chờ nhập kho
                || (!onlyNhapKho && statusPhieu.id !== WMS_STATUS.id_warehouse_wait_import) //Sd bên tủ trực, chỉ hiện wf khi phiếu không chờ nhập kho (tạo mới, chờ xuất kho)
              ) && */}
              <WfButton
                key={values[modelId.id]?.id}
                tracker={WF_TRACKER.XUAT_DIEU_CHUYEN}
                objectId={values[modelId.id]?.id}
                type={typeWf} // type 2 là của các kho 
                additionalFunc={(data) => {
                  setStatusPhieu({
                    status: data?.currCode || initialValues[modelId.id]?.statusCode,
                    id: data?.currId,
                  })
                  data?.currCode && setFieldValue(`${modelId.id}.statusCode`, data?.currCode)
                }}
              />
              {/* } */}
              {(WMS_STATUS.warehouse_export_start === statusPhieu?.status || !statusPhieu?.status) && !onlyNhapKho && modelId.title &&
                <Button type="submit" className="btn btn-fill min-w-90px spaces ">
                  Lưu
                </Button>
              }
              {(![WMS_STATUS.warehouse_new].includes(statusPhieu?.status) && statusPhieu?.status) &&
                <ButtonIn
                  className="spaces min-w-120 mx-3"
                  fetchExport={printPhieuHoanTra}
                  params={{
                    slipId: initialValues[modelId.id]?.id ?? values[modelId.id]?.id,
                    type: modelId.title ? 1 : 2, // 1 tủ trực 2 kho xuất
                    whIssueId: values[modelId.id]?.whIssueId || initialValues[modelId.id]?.whIssueId
                  }}
                />
              }
            </div>
            <FormObserver />
          </Form>
        }}
      </Formik>
      {openDialogConfirmDelete &&
        <ConfirmDialog
          show={openDialogConfirmDelete}
          onCloseClick={() => setOpenDialogConfirmDelete(false)}
          onYesClick={handleDeletePhieu}
          title="Xóa thuốc/VT"
          message={`Bạn chắc chắn muốn xóa ?`}
          yes="Xóa"
          close="Hủy"
        />
      }
    </Modal>
  );
};

export default DialogThemPhieuHoanTraVatTu;